<template>
  <div class="mx-2">
    <v-card class="mt-2">
      <v-row>
        <v-col cols="12">
          <PlanningOPCRTargetApprovalDataTable />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import PlanningOPCRTargetApprovalDataTable from "../../../components/Utils/OPCR/PlanningOPCRTargetApprovalDataTable.vue";

export default {
  components: {
    PlanningOPCRTargetApprovalDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  mounted() {},
  data: () => ({
    typeData: [],
    action: null,
    hasHead: false,
  }),
  methods: {},
};
</script>

<style></style>
